import React from 'react';
import {LoginForm} from './LoginForm';

export class Login extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="container page login">
                <div className="title">Se connecter</div>

                <h5>Remplissez le formulaire ci-dessous afin d'accéder à votre compte</h5>
                <LoginForm/>
            </div>
        );
    }
}